import { useMediaQuery, useTheme } from "@material-ui/core";

function isTouchDevice() {
  return "ontouchstart" in window || navigator?.maxTouchPoints > 0;
}

const useIsMobile = (): boolean => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"), {
    defaultMatches: typeof window !== `undefined` ? isTouchDevice() : true // Detect touch support as default isMobile on client. Default to true during SSR
  });
  return matches;
};

export default useIsMobile;
